import React from 'react';
import { SimpleGrid, Box, Text, Button, Stack, Image } from '@chakra-ui/react';
import { getAvailabilityTextAndColor } from '../utils/menu2-utils';
import { getMenuImageUrl, getMenuImagePlaceholderUrl } from '../utils/menuImageUrl';

// PRODUCT
// {
//   "category": "Gluten-free",
//   "id": "06-009",
//   "title": "Piadina con nutella gluten free",
//   "description": "Leggera e gustosa, ideale per ogni farcitura, senza tracce di glutine ma con tutto il sapore della tradizione.",
//   "descriptionShort": "Perfetta per ogni farcitura",
//   "price": "4.00",
//   "maxQuantity": "1000",
//   "extra": "",
//   "discount": "",
//   "isAvailable": true,
//   "position": 29,
//   "quantities": [
//       {
//           "qty": "1000",
//           "date": "2025-02-28T19:00:00.000Z"
//       },
//   ],
//   "quantity": 0,
//   "tempQuantities": [
//       {
//           "qty": "1000",
//           "date": "2025-02-28T19:00:00.000Z"
//       },
//   ],
//   "qtyForDate": 998
// }

function ProductGrid({
  products,
  increment,
  decrement,
  showImages,
  showPrices,
  showAvailability,
  columns,
}) {
  return (
    <SimpleGrid
      columns={columns}
      spacing={{ base: 1, sm: 2, md: 3 }}
      my={4}
      justifyItems='center'
      alignItems='stretch'
    >
      {products.map((product) => {
        // console.log(product)
        if (product.extra === 'COMBO_ONLY') return null;
        if (product.category === 'donazione') return null;
        const isCombo = !!product.products;
        const currentAvailability = parseInt(product.qtyForDate);
        // console.log('currentAvailability', currentAvailability)
        const { text: currentAvailabilityText, color: colorAvailabilityText } =
          getAvailabilityTextAndColor(currentAvailability/*, product.category*/);
        return (
          <Box
            key={product.id}
            p={{ base: 1, md: 2 }}
            border='2px solid grey'
            borderRadius={8}
            bg='#0f365f'
            w={{ base: '140px', md: '180px' }}
            mx='auto'
            display='flex'
            flexDirection='column'
            alignItems='center'
            justifyContent='flex-start'
            height='100%'
          >
            {showImages && (
              <Image
                src={getMenuImageUrl({
                  imageId: product.imageId,
                  id: product.id,
                  kind: 'product',
                })}
                fallbackSrc={getMenuImagePlaceholderUrl()}
                w={{ base: '56px', sm: '70px', md: '100px' }}
                h={{ base: '56px', sm: '70px', md: '100px' }}
                objectFit='cover'
                borderRadius={6}
                mb={2}
                border='1px solid #444'
                bg='#0f365f'
              />
            )}
            <Text
              fontWeight={600}
              color='gold'
              fontSize='sm'
              mb={1}
              textAlign='center'
              noOfLines={2}
              minH='2.8em'
              lineHeight='1.4em'
              display='-webkit-box'
              style={{ WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
            >
              {product.title}
            </Text>
            {(currentAvailability <= 0 || (showAvailability && product.isAvailable)) && (
              <Text color={colorAvailabilityText} fontSize='xs' mb={1} fontWeight={500}>
                {currentAvailabilityText} {/*{currentAvailability}*/}
              </Text>
            )}
            {showPrices && (
              <Text
                color='white'
                fontSize='sm'
                mb={1}
                style={{
                  textDecoration:
                    product.isAvailable && currentAvailability > 0 ? '' : 'line-through',
                }}
              >
                € {product.price}
              </Text>
            )}
            {!product.isAvailable && (
              <Text color='white' fontSize='sm' mb={1}>
                Non disponibile
              </Text>
            )}
            <Stack direction='row' spacing={1} align='center' mt='auto'>
              <Button
                isDisabled={product.quantity === 0}
                size={{ base: 'md', md: 'lg', lg: 'md' }}
                onClick={() => decrement(product.id, isCombo ? 'combos' : 'products')}
              >
                -
              </Button>
              <Text color='white' fontSize={{ base: 'md', md: 'xl', lg: 'md' }} fontWeight={600}>
                {product.quantity}
              </Text>
              <Button
                isDisabled={!(product.isAvailable && currentAvailability > 0)}
                size={{ base: 'md', md: 'lg', lg: 'md' }}
                onClick={() => increment(product.id, isCombo ? 'combos' : 'products')}
              >
                +
              </Button>
            </Stack>
          </Box>
        );
      })}
    </SimpleGrid>
  );
}

export default ProductGrid;
